import { axiosClient } from './AxiosClient';
import { IUser } from '../types';
import { store } from '../redux';
import { deleteAuthenticationAction, upsertAuthenticationAction } from '../redux/actions/authentication.actions';

interface Authentication {
  user: any;
  jwt: string;
}

const signUp = (
  username: string,
  email: string,
  password: string,
  name: string,
  surname: string,
  phone: string,
  partnerCode: string
) => {
  return new Promise<void>((resolve, reject) => {
    axiosClient
      .post<Authentication>('auth/local/register', {
        email,
        username,
        password,
        name,
        surname,
        phone,
        partnerCode,
      })
      .then((value) => {
        setToken(value.data);

        store.dispatch(upsertAuthenticationAction(value.data.user, value.data.jwt));

        resolve();
      })
      .catch((reason) => {
        reject(reason);
      });
  });
};

const signIn = (identifier: string, password: string) => {
  return new Promise<void>((resolve, reject) => {
    axiosClient
      .post<Authentication>('auth/local', { identifier, password })
      .then((value) => {
        setToken(value.data);

        store.dispatch(upsertAuthenticationAction(value.data.user, value.data.jwt));

        resolve();
      })
      .catch((reason) => {
        reject(reason);
      });
  });
};

const setToken = (token: Authentication) => {
  localStorage.setItem('user', JSON.stringify(token.user));
  localStorage.setItem('jwt', token.jwt);
  axiosClient.defaults.headers['Authorization'] = `Bearer ${token.jwt}`;
};

const signOut = () => {
  localStorage.removeItem('jwt');
  localStorage.removeItem('user');
  delete axiosClient.defaults.headers['Authorization'];

  store.dispatch(deleteAuthenticationAction());
};

const isSignedIn = (): IUser | null => {
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : null;

  return user ? user : null;
};

const forgotPassword = (email: string) => {
  return new Promise<void>((resolve, reject) => {
    axiosClient
      .post('auth/forgot-password', { email })
      .then(() => {
        resolve();
      })
      .catch((reason) => {
        reject(reason);
      });
  });
};

const resetPassword = (code: string, password: string, passwordConfirmation: string) => {
  return new Promise<void>((resolve, reject) => {
    axiosClient
      .post('auth/reset-password', { code, password, passwordConfirmation })
      .then(() => {
        resolve();
      })
      .catch((reason) => {
        reject(reason);
      });
  });
};

export const Auth = {
  signUp,
  signIn,
  signOut,
  isSignedIn,
  forgotPassword,
  resetPassword,
};
